import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const safeDecode = (token) => {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

const initialToken = localStorage.getItem("token") || "";
const decoded = initialToken ? safeDecode(initialToken) : null;

const initialState = {
  token: initialToken,
  userId: decoded?.userId || "", // your JWT has "userId"
  phone: decoded?.phone || "",
  role: decoded?.role || "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      const token = action.payload || "";
      state.token = token;

      if (token) {
        localStorage.setItem("token", token);
        const d = safeDecode(token);
        state.userId = d?.userId || "";
        state.phone = d?.phone || "";
        state.role = d?.role || "";
      } else {
        localStorage.removeItem("token");
        state.userId = "";
        state.phone = "";
        state.role = "";
      }
    },
    logout: (state) => {
      state.token = "";
      state.userId = "";
      state.phone = "";
      state.role = "";
      localStorage.removeItem("token");
    },
  },
});

export const { setToken, logout } = authSlice.actions;
export default authSlice.reducer;

// selectors
export const selectToken = (s) => s.auth.token;
export const selectUserId = (s) => s.auth.userId;
export const selectIsAuthed = (s) => !!s.auth.token;
